export default __webpack_public_path__ + "static/media/swipe.7ef42ea0.gif";